import { AlertColor } from '@mui/material'
import { appStore } from '@tom-ui/utils'
import { action, makeObservable, observable, runInAction } from 'mobx'
import { ReactNode } from 'react'

interface DialogOptions {
  hidePrimaryAction?: boolean
  hideSecondaryAction?: boolean
  primaryActionText?: string
  secondaryActionText?: string
  maxWidth?: 'sm' | 'md' | 'lg'
}

export class AppViewStore {
  openDialog = false
  dialogContent?: ReactNode
  dialogWarning = ''
  dialogTitle: string | undefined
  showAlertWithAction = false
  openFileUploadDialog = false
  isLoading = false
  createdVesselVisitId?: number
  createdRailVisitId?: number
  options?: DialogOptions

  confirmHandler?: (cancel: boolean) => void = undefined

  constructor() {
    makeObservable(this, {
      openDialog: observable,
      dialogTitle: observable,
      dialogContent: observable,
      dialogWarning: observable,
      options: observable,
      isLoading: observable,
      openFileUploadDialog: observable,
      showAlertWithAction: observable,
      createdVesselVisitId: observable,
      createdRailVisitId: observable,

      setOpenDialog: action,
      setOpenConfirmDialog: action,
      setShowAlert: action,
      showToDoAlert: action,
    })
  }

  setOpenConfirmDialog = (
    open: boolean,
    content?: ReactNode,
    title?: string,
    warning?: string,
    options?: DialogOptions,
  ): Promise<boolean> => {
    if (open) {
      this.dialogContent = content ?? ''
      this.dialogWarning = warning ?? ''
      this.dialogTitle = title ?? ''
      this.options = options ?? undefined
    }
    this.openDialog = open
    return new Promise(resolve => {
      runInAction(() => {
        this.confirmHandler = resolve
      })
    })
  }

  setShowAlert = (severity?: AlertColor, message?: string, action?: ReactNode) => {
    if (message) {
      appStore.setShowAlert(severity ?? 'success', message, action)
    }
  }

  showToDoAlert = () => {
    appStore.setShowAlert('error', 'Under construction...')
  }

  setOpenDialog(open: boolean) {
    this.openDialog = open
  }

  setCreatedVesselVisitId(id: number) {
    this.createdVesselVisitId = id
    this.createdRailVisitId = undefined
  }

  setCreatedRailVisitId(id: number) {
    this.createdRailVisitId = id
    this.createdVesselVisitId = undefined
  }

  showLoader = () => {
    runInAction(() => {
      this.isLoading = true
    })
  }

  hideLoader = () => {
    runInAction(() => {
      this.isLoading = false
    })
  }
}
